import TitleWrapper from './TitleWrapper';

export { TitleWrapper };
